import React from 'react';
import {FormattedMessage} from 'react-intl';
import {pathnames as P} from '../../../_common/constants/pathnames';
import {subjects as S} from '../../../_common/constants/permissionSubjects';
import AsideMenuLink from '../../../_common/components/Aside/AsideMenuLink';

const UsersActionsLink = () => {

  return (
    <AsideMenuLink
      pathname={P.USERS_ACTIONS_PAGE}
      subject={S.USERS_ACTIONS_PAGE}
      icon={'Logs_grey.svg'}
      label={<FormattedMessage id="users-actions-page-link" defaultMessage="Users actions page"/>}
    />
  );
};

export default UsersActionsLink;
